<template>
<v-container class="text-center">
  <h1>What is Guiomentor</h1>
  <v-row>
    <v-col cols="12" md="6" lg="6">
      <lottie-animation
          ref="anim"
          :animationData="require('@/assets/animations/learning_concept.json')"
          :loop="true"
          :autoPlay="true"
      />
    </v-col>
    <v-col cols="12" md="6" lg="6">
      <v-container class="left">
        <p class="normal-text left">
          Guiomentor is a platform which guides learners with the existing learning materials,
          targeting different levels of education.
        </p>
        <p class="normal-text left">
          We take care of you right away at your current level of education until you finalize your career.
        </p>
      </v-container>
    </v-col>
  </v-row>

  <v-row justify="space-between" align="center">
    <v-col cols="12" md="6" lg="6">
      <v-card color="primary" class="py-3"  >
        <h3 class="text-center text-center-custom " >
          Are you a Teacher ?
        </h3>

        <v-card-subtitle>
          <v-btn rounded to="/signup?type=mentor">Volunteer</v-btn>
        </v-card-subtitle>
      </v-card>
    </v-col>

    <v-col cols="12" md="6" lg="6">
      <v-card color="primary" class="py-3"  >
        <h3 class="text-center text-center-custom">
            Are you a Student ?
        </h3>

        <v-card-subtitle>
          <v-btn rounded to="/signup?type=student">Get Started</v-btn>
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import LottieAnimation from 'lottie-web-vue'

export default {
  name: "About",
  components: {
    LottieAnimation
  }
}
</script>

<style scoped>

.normal-text {
  font-size: 1.4em;
}

.text-center-custom {
  color: white;
}

.custom-container {
  background: #a4b7a4;
}

</style>
